<template>
  <BasePopup
    :visible="v3PopupState.poolPopupState"
    :mask-closable="true"
    :show-close-btn="true"
    :show-confirm-btn="false"
    popup-class="pool-popup"
    @close="handleClose"
  >
    <div class="v3-popup-content-title popup-title-pool"></div>
    <div class="v3-popup-content-content">
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>獎勵名稱</th>
              <th>概率</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in rewardList" :key="index">
              <td>{{ item.name }}</td>
              <td>{{ item.probability }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </BasePopup>
</template>

<script setup>
import { inject, reactive, watch } from "vue";
import { rewardList } from "@/config/rewards";
import { point } from "@/utils";
import BasePopup from "./BasePopup.vue";

const v3PopupState = inject("v3PopupState", reactive({}));

// 监听弹窗状态，打点上报
watch(
  () => v3PopupState.poolPopupState,
  (value) => {
    if (value) {
      point({
        eventName: 'show_popup',
        eventType: '奖池信息弹窗'
      });
    }
  }
);

// 关闭弹窗
const handleClose = () => {
  v3PopupState.poolPopupState = false;
};
</script>

<style scoped lang="less">
// 需要引入 mixin
@import "@/assets/less/v3-popup.less";

.pool-popup {
  .popup-title-pool {
    width: 403px;
    height: 142px;
    background: url("@/assets/images/popup/popup-title-pool.png") no-repeat center;
    background-size: contain;
    margin: -80px auto 0;
  }

  .v3-popup-content-content {
    height: 450px;
    margin: 10px auto;
    padding: 0;
    border: none;
    border-radius: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 85%;
  }

  .table-wrapper {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding-right: 10px;
    .custom-scrollbar();
  }

  table {
    width: 100%;
    border-radius: 14px;
    border: 1px solid #f8dfa8;
    overflow: hidden;

    th {
      background: #ffe1a6;
      font-weight: bold;
      color: #9e5f29;
      font-size: 24px;
      padding: 20px 10px;
      text-align: center;
      white-space: nowrap;
    }

    td {
      padding: 20px 10px;
      font-size: 22px;
      color: #9e5f29;
      text-align: center;
      background-color: white;
    }

    tbody tr:nth-child(odd) td {
      background-color: #fff;
    }

    tbody tr:nth-child(even) td {
      background-color: #fffbf2;
    }
  }
}
</style>
